import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAppForm } from "@/hooks/useCreateForm";
import { authClient } from "@/lib/authClient";
import { queryClient, trpc } from "@/lib/trpcClient";

export const Route = createFileRoute("/_authed/_org/settings/development")({
  component: RouteComponent,
});

function RouteComponent() {
  const {
    data: { user },
  } = useSuspenseQuery(trpc.auth.session.queryOptions());

  const twoFactorForm = useAppForm({
    defaultValues: {
      password: "",
    },
    onSubmit: async ({ value: { password } }) => {
      if (user?.twoFactorEnabled) {
        const { error } = await authClient.twoFactor.disable({
          password,
        });
        if (error) {
          toast.error(error.message);
        } else {
          toast.success("Two factor disabled");
        }
      } else {
        const { error } = await authClient.twoFactor.enable({
          password,
        });
        if (error) {
          toast.error(error.message);
        } else {
          toast.success("Two factor enabled");
        }
      }
      queryClient.invalidateQueries(trpc.auth.session.queryOptions());
    },
  });

  return (
    <Card className="w-full max-w-4xl" variant="compact">
      <CardHeader>
        <CardTitle>
          {user?.twoFactorEnabled ? "Disable" : "Enable"} 2fa
        </CardTitle>
        <CardDescription>
          This option in only available in <strong>Dev and Staging</strong>{" "}
          environments. 2fa is mandated in production.
        </CardDescription>
        <CardContent className="px-0">
          <form
            className="mt-4 flex items-end gap-2"
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              twoFactorForm.handleSubmit();
            }}
          >
            <twoFactorForm.AppField
              children={(field) => (
                <field.PasswordField label="Password" required={true} />
              )}
              name="password"
            />
            <Button className="h-9" type="submit">
              Submit
            </Button>
          </form>
        </CardContent>
      </CardHeader>
    </Card>
  );
}
